import { TooltipContent } from "../..";
import { TooltipSourceType } from "./TooltipSourceType";

export class TooltipSource {
    content: TooltipContent;
    type: TooltipSourceType;

    constructor(type: TooltipSourceType, content: TooltipContent) {
        this.type = type;
        this.content = content;
    }

    public isEmpty(): boolean {
        return this.content == null;
    }
}
